import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface HeadingBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

const HeadingBlockRenderer: React.FC<HeadingBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const text = String(s.text ?? '');
  const fontSize =
    typeof s.fontSize === 'number' && Number.isFinite(s.fontSize)
      ? s.fontSize
      : Math.round(config.fontBoyutu * 1.35);
  const color = typeof s.color === 'string' ? s.color : config.anaRenk;
  const alignRaw = s.align;
  const align =
    alignRaw === 'center' || alignRaw === 'right' || alignRaw === 'left' ? alignRaw : 'left';

  return (
    <div
      style={{
        fontFamily: config.font,
        fontSize,
        fontWeight: 700,
        color,
        textAlign: align,
        lineHeight: 1.25,
        margin: 0,
        padding: 0,
      }}
    >
      {text}
    </div>
  );
};

export default HeadingBlockRenderer;
